import { render, staticRenderFns } from "./ReplaceFile.vue?vue&type=template&id=5d01f0f8&scoped=true&"
import script from "./ReplaceFile.vue?vue&type=script&lang=js&"
export * from "./ReplaceFile.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceFile.vue?vue&type=style&index=0&id=5d01f0f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01f0f8",
  null
  
)

export default component.exports